<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    default: '',
  },

  photo: {
    type: String,
    default: '',
  },

  position: {
    type: String,
    default: '',
  },

  resume: {
    type: String,
    default: '',
  },

  intro: {
    type: String,
    default: '',
  },

  targ: {
    type: String,
    default: '',
  },

  size: {
    type: String,
    default: 'medium',
  },

  responsive: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="people-card">
    <div class="relative h-160 <md:h-200">
      <img
        class="lazyload block h-full rounded-4 object-cover <md:object-contain <md:object-left"
        :class="{
          'w-160 <md:w-full': props.size === 'medium' && props.responsive,
          'w-160': props.size === 'medium' && !props.responsive,
          'w-324 <2xl:w-297 <md:w-full': props.size === 'large',
        }"
        :data-src="props.photo"
        :alt="props.name"
      >
      <div
        class="absolute top-50% h-64 rounded-3 bg-[length:38px_38px] bg-[url(@/assets/about/bg-1.svg)] bg-white bg-left-top bg-no-repeat px-5 shadow-[0_0_16px_0_rgba(0,0,0,0.04)] -translate-y-50%"
        :class="{
          'left-135 max-w-120 min-w-88 <2xl:max-w-100 <md:left-auto <md:right-0 <md:w-150 <md:max-w-none': props.size === 'medium' && props.responsive,
          'left-135 max-w-120 min-w-88 <2xl:max-w-100': props.size === 'medium' && !props.responsive,
          'left-259 w-157 <2xl:left-232 <2xl:w-130 <md:left-auto <md:right-0': props.size === 'large',
        }"
      >
        <p class="mb-0 mt-8 truncate text-center text-14 text-brand-primary font-medium" :title="props.position">{{ props.position }}</p>
        <p class="mb-0 mt-10 truncate text-center text-16 text-brand-normal font-normal" :title="props.name">{{ props.name }}</p>
      </div>
      <span class="absolute top-0 block h-20 w-70 truncate rounded-[0_0_4px_0] bg-[linear-gradient(-66deg,#5be6ff_0%,#1180ff_100%)] text-center text-12 color-hex-fff leading-20 tracking--0.5px shadow-[0_0_1px_0_rgba(0,0,0,0.1)]" v-if="targ">
        {{ props.targ }}
      </span>
    </div>

    <p
      class="mx-0 mb-0 mt-10 max-h-120 overflow-x-auto whitespace-pre-wrap text-14 text-brand-gray font-normal leading-20"
      :title="props.resume"
      v-if="props.intro"
    >
      {{ props.intro }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
</style>
